var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "edit-itemServices" } }, [
    _c(
      "form",
      {
        attrs: {
          id: "items-services-edit-form",
          "data-abide": "",
          novalidate: "",
        },
      },
      _vm._l(_vm.sections, function (section, secIndex) {
        return _c("div", { key: secIndex }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: section.forReference,
                    expression: "section.forReference",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                ],
                staticClass: "section-optional-items-checkbox",
                attrs: {
                  id: "tender-section-optional-items",
                  type: "checkbox",
                  name: "tender-section-optional-items",
                },
                domProps: { checked: section.checked },
                on: {
                  change: function (event) {
                    return _vm.isAddendum
                      ? _vm.addendumToggleSecForRef(
                          section,
                          secIndex,
                          "checked",
                          event.target.checked
                        )
                      : _vm.onOptionalChange(
                          secIndex,
                          "checked",
                          event.target.checked
                        )
                  },
                },
              }),
              _vm._v(" "),
              section.forReference
                ? _c(
                    "div",
                    {
                      staticClass: "title",
                      class: _vm.highlightDeleteChange(section.addendumLabel),
                      attrs: {
                        id: _vm.addId("tender.section.title", secIndex),
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(section.title) + "\n        "
                      ),
                    ]
                  )
                : _c("input", {
                    class: _vm.highlightDeleteChange(section.addendumLabel),
                    attrs: {
                      id: _vm.addId("tender.section.title", secIndex),
                      type: "text",
                      placeholder: _vm.$t("tender.section.title"),
                      disabled: _vm.disabledDeletedItem(section.addendumLabel),
                    },
                    domProps: { value: section.title },
                    on: {
                      change: function (event) {
                        return _vm.onSectionChange(
                          secIndex,
                          "title",
                          event.target.value,
                          section.addendumLabel
                        )
                      },
                    },
                  }),
              _vm._v(" "),
              _c(
                "dotted-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !section.forReference || section.checked,
                      expression: "!section.forReference || section.checked",
                    },
                  ],
                  attrs: {
                    id: _vm.addId("section-actions-dropdown", secIndex),
                  },
                },
                _vm._l(
                  _vm.filterItemActions(
                    section.addendumLabel,
                    section.forReference
                      ? _vm.sectionForReferActions
                      : _vm.sectionActions,
                    secIndex
                  ),
                  function (item) {
                    return _c(
                      "li",
                      {
                        key: _vm.addId("section.action", secIndex, item.action),
                        class: _vm.highlightDeleteActions(
                          item.action,
                          section.addendumLabel
                        ),
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              id: _vm.addId(
                                "section.action",
                                secIndex,
                                item.action
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleActions(
                                  section,
                                  item.action,
                                  secIndex,
                                  -1,
                                  secIndex
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          section.sectionDesc !== undefined && section.sectionDesc !== null
            ? _c("div", [
                section.forReference
                  ? _c(
                      "div",
                      {
                        staticClass: "description",
                        class: _vm.highlightDeleteChange(section.addendumLabel),
                        attrs: {
                          id: _vm.addId("tender.section.sectionDesc", secIndex),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(section.sectionDesc) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c("textarea", {
                      directives: [{ name: "autosize", rawName: "v-autosize" }],
                      staticClass: "autosize",
                      class: _vm.highlightDeleteChange(section.addendumLabel),
                      attrs: {
                        id: _vm.addId("tender.section.sectionDesc", secIndex),
                        type: "text",
                        placeholder: _vm.$t("tender.section.description"),
                        disabled: _vm.disabledDeletedItem(
                          section.addendumLabel
                        ),
                      },
                      domProps: { value: section.sectionDesc },
                      on: {
                        change: function (event) {
                          return _vm.onSectionChange(
                            secIndex,
                            "sectionDesc",
                            event.target.value
                          )
                        },
                      },
                    }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !section.forReference ||
                    section.checked ||
                    ((_vm.deep(section, "lineItems.length") > 1 ||
                      (_vm.deep(section, ["lineItems", 0, "addendumLabel"]) &&
                        _vm.deep(section, ["lineItems", 0, "addendumLabel"]) !==
                          _vm.addendumChangeType.pending.added)) &&
                      _vm.isAddendum),
                  expression:
                    "!section.forReference\n          || section.checked\n          || ((deep(section, 'lineItems.length') > 1 || (deep(section, ['lineItems', 0, 'addendumLabel']) && deep(section, ['lineItems', 0, 'addendumLabel']) !== addendumChangeType.pending.added)) && isAddendum)",
                },
              ],
            },
            [
              _c("table", [
                _c("thead", [
                  _c("th", { staticClass: "number" }, [
                    _vm._v("\n              #\n            "),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticStyle: { "padding-left": "0" } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("tender.section.descOfWork")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "qty-text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("tender.section.qty")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "unit-text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("tender.section.unit")) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(section.lineItems, function (line, lineIndex) {
                      return [
                        _c(
                          "tr",
                          {
                            key: lineIndex,
                            staticClass: "set-border-top",
                            class: _vm.highlightDeleteChange(
                              section.addendumLabel,
                              line.addendumLabel
                            ),
                            on: {
                              paste: function (e) {
                                return _vm.onRowPaste(e, section, secIndex)
                              },
                            },
                          },
                          [
                            _c("td", { staticClass: "number" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(line.itemNo) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  "padding-top": "0",
                                  width: "60%",
                                },
                              },
                              [
                                _c("textarea", {
                                  directives: [
                                    { name: "autosize", rawName: "v-autosize" },
                                  ],
                                  staticClass: "autosize desc-work",
                                  attrs: {
                                    id: _vm.addId(
                                      "line.desc",
                                      secIndex,
                                      lineIndex
                                    ),
                                    placeholder: _vm.$t(
                                      "tender.section.description"
                                    ),
                                    type: "text",
                                    disabled: _vm.disabledDeletedItem(
                                      section.addendumLabel,
                                      line.addendumLabel
                                    ),
                                    required:
                                      section.checked || !section.forReference,
                                  },
                                  domProps: { value: line.itemDesc },
                                  on: {
                                    change: function (event) {
                                      return _vm.onLineChange(
                                        secIndex,
                                        lineIndex,
                                        "itemDesc",
                                        event.target.value,
                                        line.addendumLabel
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticStyle: { width: "10%" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "decimal",
                                      pattern: function (val) {
                                        return (Number(val) || 0) > 0
                                      },
                                      required:
                                        (section.checked ||
                                          !section.forReference) &&
                                        !_vm.disabledDeletedItem(
                                          section.addendumLabel,
                                          line.addendumLabel
                                        ),
                                    },
                                    expression:
                                      "{\n                      type: 'decimal',\n                      pattern: (val) => (Number(val) || 0) > 0,\n                      required: (section.checked || !section.forReference) && !disabledDeletedItem(section.addendumLabel, line.addendumLabel)\n                    }",
                                  },
                                ],
                                staticClass: "qty-input",
                                attrs: {
                                  id: _vm.addId(
                                    "line.qty",
                                    secIndex,
                                    lineIndex
                                  ),
                                  type: "text",
                                  disabled: _vm.disabledDeletedItem(
                                    section.addendumLabel,
                                    line.addendumLabel
                                  ),
                                },
                                domProps: { value: line.itemQty },
                                on: {
                                  change: function (event) {
                                    return _vm.onLineChange(
                                      secIndex,
                                      lineIndex,
                                      "itemQty",
                                      event.target.value,
                                      line.addendumLabel
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "row",
                                staticStyle: { "padding-right": "0" },
                                attrs: {
                                  id: _vm.addId(
                                    "line.unit",
                                    secIndex,
                                    lineIndex
                                  ),
                                },
                              },
                              [
                                _c("HKLSelect", {
                                  staticClass:
                                    "small-8 medium-8 large-8 columns",
                                  attrs: {
                                    value: line.itemUnit || undefined,
                                    options: _vm.unitHklOptions,
                                    disabled: _vm.disabledDeletedItem(
                                      section.addendumLabel,
                                      line.addendumLabel
                                    ),
                                    showSearch: true,
                                    placeholder: "",
                                  },
                                  on: {
                                    change: function (value) {
                                      return _vm.onLineChange(
                                        secIndex,
                                        lineIndex,
                                        "itemUnit",
                                        value || ""
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "dotted-dropdown",
                                  {
                                    staticClass:
                                      "small-2 medium-2 large-2 columns",
                                    staticStyle: { padding: "0 0" },
                                    attrs: {
                                      id: _vm.addId(
                                        "line-actions-dropdown",
                                        secIndex,
                                        lineIndex
                                      ),
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.filterItemActions(
                                        line.addendumLabel,
                                        _vm.lineActions,
                                        secIndex,
                                        lineIndex
                                      ),
                                      function (item) {
                                        return [
                                          _c(
                                            "li",
                                            {
                                              key: _vm.addId(
                                                "line.action",
                                                secIndex,
                                                lineIndex,
                                                item.action
                                              ),
                                              class: _vm.disableActions(
                                                item.action,
                                                section.addendumLabel,
                                                line.addendumLabel
                                              ),
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id: _vm.addId(
                                                      "line.action",
                                                      secIndex,
                                                      lineIndex,
                                                      item.action
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleActions(
                                                        line,
                                                        item.action,
                                                        secIndex,
                                                        lineIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(item.name) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          secIndex + 1 !== _vm.sections.length
            ? _c("hr", { staticClass: "section-border-hr" })
            : _vm._e(),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", [
      _c("hr", { staticClass: "section-border-hr" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("input", {
          staticClass: "section-optional-items-checkbox",
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.allowServiceAddOthers },
          on: {
            change: function (event) {
              return _vm.updateServiceAddOthers(event.target.checked)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "title", class: _vm.highlightAllowServiceAddOthers },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("tender.section.unExternalOthers")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "deleteModal",
        staticClass: "reveal",
        attrs: { id: "deleteModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix modal-container" }, [
          _c("p", { staticClass: "confirm-header" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("tender.section.deleteWarning", [_vm.deleteActionName])
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeAlertModal()
                  },
                },
              },
              [_vm._v("\n          " + _vm._s(_vm.$t("no")) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.confirmDelete()
                  },
                },
              },
              [_vm._v("\n          " + _vm._s(_vm.$t("yes")) + "\n        ")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }